import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { NessAppPlusHomeTmplS } from '../../../Home/S/Tmpl/module/NessAppPlusHomeTmplS.js';
import { filter, find, go, html, join, last, pluck, sel, strMap, unique } from 'fxjs/es';

export const customFilterCategoryListTmpl = (custom_filter_menu_data) => {
  if (UtilS.isEmpty(custom_filter_menu_data)) return '';

  return NessAppPlusHomeTmplS.customProductsCategory('custom')(custom_filter_menu_data, false);
};

export const customCategiryListTmpl = (custom_product_cate_list, custom_filter_menu_data, products) => {
  const available_cate_list = getAvailableCateLists(custom_filter_menu_data, products);

  return html` <ul class="custom__category category_list">
    ${go(
      custom_product_cate_list,
      strMap(({ id, name, selected }) => {
        const selected_class = selected ? 'selected' : '';
        return html`
          <li
            class="custom__category__item ${selected_class} category"
            data-id="${id}"
            ${id === 'all' || available_cate_list.includes(id) ? '' : `style='display : none'`}
          >
            <span class="custom__category__cate_list_name">${name}</span>
          </li>
        `;
      }),
      join(''),
    )}
  </ul>`;
};

const getAvailableCateLists = (custom_filter_menu_data, products) => {
  const cur_forlder_name = go(
    custom_filter_menu_data,
    find(({ selected }) => selected),
    sel('asset_folder_name'),
  );

  return go(
    products,
    filter((product) => {
      const { name } = last(product.image_folders);
      if (cur_forlder_name === 'all') return true;
      return cur_forlder_name === name;
    }),
    pluck('_'),
    pluck('stores_product'),
    pluck('sp_cate_list_id'),
    unique,
  );
};
